import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// context
import { Dialog, Header, CloseButton } from "core/Dialog";

// components
import Content from "./Content";

// styles
import { convertPxToRem } from "frontend/components/helpers";

const CloseButtonStyled = styled(CloseButton)`
    padding: 0px ${convertPxToRem(24)};
`;

const DialogContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

const ContentWrapper = styled.div`
    padding: 0;
    text-align: left;
    overflow: hidden;
    flex: 1;
`;

// component
export const Modal = ({ userMessage, isVisible, onClose }) => {
    const { modalImageUrl } = userMessage;

    const width = modalImageUrl ? convertPxToRem(720) : convertPxToRem(430);

    return (
        <Dialog isVisible={isVisible} onClose={onClose} width={width}>
            <DialogContent>
                <Header headerHeight="63px">
                    <CloseButtonStyled onClick={onClose} />
                </Header>
                <ContentWrapper>
                    <Content userMessage={userMessage} />
                </ContentWrapper>
            </DialogContent>
        </Dialog>
    );
};

export default Modal;

// prop-types
Modal.propTypes = {
    userMessage: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
